import { render, staticRenderFns } from "./courseTeachers.vue?vue&type=template&id=0283f806&scoped=true&"
import script from "./courseTeachers.vue?vue&type=script&lang=js&"
export * from "./courseTeachers.vue?vue&type=script&lang=js&"
import style0 from "./courseTeachers.vue?vue&type=style&index=0&id=0283f806&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0283f806",
  null
  
)

export default component.exports